import {
  DASHBOARD_DOCUMENT_STATUS,
  DASHBOARD_EDITOR_LIST,
  DASHBOARD_FILE_WIDGET,
  SET_DASHBOARD_DATA,
  DOWNLOAD_DASHBOARD_DATA,
  EMAIL_DASHBOARD_DATA,
  LICENSE_DASHBOARD_DATA,
  SEARCH_COMPANY_DATA,
  CREATE_COMPANY,
  GET_COUNTRIES,
  UPDATE_COMPANY,
  CLEAR_COMPANY_STATUS,
  GET_SUBSCRIPTION_DEFAULTS
} from '../actions/DashboardActions'

const initialState = {
  fileCount: {},
}

const dashboardReducer = function (state = initialState, action) {
  switch (action.type) {
    case DASHBOARD_FILE_WIDGET:
      state = {
        ...state,
        fileCount: action.payload?.data,
      }
      break
    case DASHBOARD_EDITOR_LIST:
      console.log("Widget Response :::",action.payload?.data);
      state = {
        ...state,
        editorList: action.payload?.data.filesResponses,
      }
      break
    case DASHBOARD_DOCUMENT_STATUS:

      state = {
        ...state,
        docStatusList: action.payload?.data,
      }
      break
    case SET_DASHBOARD_DATA:
        state = {
          ...state,
         dashboardData: action.payload?.data,
        }
      break
    case DOWNLOAD_DASHBOARD_DATA:
        state = {
          ...state,
         downloadData: action.payload,
        }
      break
    case EMAIL_DASHBOARD_DATA:
      console.log('Action payload', action.payload);
        state = {
          ...state,
         emailData: action.payload,
        }
      break
      case SEARCH_COMPANY_DATA:
        state = {
          ...state,
         licenseData: action.payload, //search company data
        }
      break      
    case LICENSE_DASHBOARD_DATA:
      state = {
        ...state,
       licenseData: action.payload,
      }
    break
    case CREATE_COMPANY:
      state = {
        ...state,
       companyResponse: action.payload,
      }
    break
    case GET_COUNTRIES:
      state = {
        ...state,
       countriesResponse: action.payload,
      }
    break

    case UPDATE_COMPANY:
      state = {
        ...state,
       updateCompanyResponse: action.payload,
      }
    break
    case CLEAR_COMPANY_STATUS:
      state = {
             ...state,
              companyResponse: action.payload,
              updateCompanyResponse:action.payload,
              companyDeleteResponse:action.payload,
              companyActivateDeActivateResponse:action.payload,
              updateCompanyResponse:action.payload,
       }
    break
    case GET_SUBSCRIPTION_DEFAULTS:
      state = {
        ...state,
        subscriptionDefaults: action.payload,
      }
      break;
    default:
      state = { ...state }
      break
  }
  return state
}
export default dashboardReducer
